export type ResourceFormat = "PDF" | "Doc" | "Link" | "eBook" | "Video";
export type ResourceCategory = "Learning" | "Portfolio" | "Interview" | "Research" | "Tools";

export interface VaultResource {
  id: string;
  title: string;
  url: string;
  domain: string;
  format: ResourceFormat;
  category: ResourceCategory;
  tags: string[];
  sharedBy: string;
  sharedDate: string;
  sessionId: string | null;
  taskId: string | null;
  starred: boolean;
  description: string;
}

export interface SessionGroup {
  id: string;
  title: string;
  date: string;
  mentorName: string;
}

export const sessionGroups: SessionGroup[] = [
  { id: "s1", title: "Portfolio Review", date: "Apr 9, 2026", mentorName: "Dr. Sarah Chen" },
  { id: "s2", title: "UX Research Methods", date: "Mar 26, 2026", mentorName: "Dr. Sarah Chen" },
  { id: "s3", title: "Intro Call", date: "Feb 28, 2026", mentorName: "Marcus Rodriguez" },
  { id: "s4", title: "System Design Deep Dive", date: "Apr 5, 2026", mentorName: "Dr. Sarah Chen" },
  { id: "s5", title: "Interview Prep Session", date: "Mar 22, 2026", mentorName: "Marcus Rodriguez" },
];

export const vaultResources: VaultResource[] = [
  {
    id: "rv1",
    title: "React Hooks Official Reference",
    url: "https://react.dev/reference/react",
    domain: "react.dev",
    format: "Link",
    category: "Learning",
    tags: ["React", "Hooks"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Apr 5, 2026",
    sessionId: "s4",
    taskId: null,
    starred: true,
    description: "The official React documentation covering all built-in hooks with examples and best practices.",
  },
  {
    id: "rv2",
    title: "System Design Primer",
    url: "https://github.com/donnemartin/system-design-primer",
    domain: "github.com",
    format: "Doc",
    category: "Learning",
    tags: ["System Design", "Architecture"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Apr 5, 2026",
    sessionId: "s4",
    taskId: null,
    starred: true,
    description: "A comprehensive guide to system design concepts, patterns, and interview preparation.",
  },
  {
    id: "rv3",
    title: "Building a REST API with Node.js",
    url: "https://youtube.com/watch?v=rest-api-nodejs",
    domain: "youtube.com",
    format: "Video",
    category: "Portfolio",
    tags: ["Node.js", "API", "Backend"],
    sharedBy: "Marcus Rodriguez",
    sharedDate: "Mar 22, 2026",
    sessionId: "s5",
    taskId: null,
    starred: false,
    description: "Step-by-step video tutorial on building production-ready REST APIs with Node.js and Express.",
  },
  {
    id: "rv4",
    title: "The STAR Method for Behavioral Interviews",
    url: "https://hbr.org/star-method",
    domain: "hbr.org",
    format: "Link",
    category: "Interview",
    tags: ["Interview", "STAR"],
    sharedBy: "Marcus Rodriguez",
    sharedDate: "Mar 22, 2026",
    sessionId: "s5",
    taskId: null,
    starred: false,
    description: "Harvard Business Review guide on using the STAR framework to answer behavioral interview questions effectively.",
  },
  {
    id: "rv5",
    title: "TypeScript Deep Dive",
    url: "https://basarat.gitbook.io/typescript",
    domain: "gitbook.io",
    format: "eBook",
    category: "Learning",
    tags: ["TypeScript"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Mar 10, 2026",
    sessionId: "s2",
    taskId: null,
    starred: false,
    description: "A free, comprehensive eBook covering TypeScript from basics to advanced patterns used in production.",
  },
  {
    id: "rv6",
    title: "Refactoring UI — Design Principles for Devs",
    url: "https://refactoringui.com",
    domain: "refactoringui.com",
    format: "eBook",
    category: "Portfolio",
    tags: ["UI Design", "Portfolio"],
    sharedBy: "David Kim",
    sharedDate: "Feb 28, 2026",
    sessionId: "s3",
    taskId: null,
    starred: false,
    description: "Practical design tips for developers — covers spacing, color, typography, and visual hierarchy.",
  },
  {
    id: "rv7",
    title: "NNGroup Case Study Templates",
    url: "https://nngroup.com/templates",
    domain: "nngroup.com",
    format: "Doc",
    category: "Portfolio",
    tags: ["Case Study", "UX"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Apr 9, 2026",
    sessionId: "s1",
    taskId: null,
    starred: false,
    description: "Ready-to-use templates for structuring UX case studies that impress hiring managers.",
  },
  {
    id: "rv8",
    title: "Google UX Design Certificate",
    url: "https://coursera.org/google-ux",
    domain: "coursera.org",
    format: "Video",
    category: "Learning",
    tags: ["UX Design", "Certificate"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Apr 9, 2026",
    sessionId: "s1",
    taskId: null,
    starred: false,
    description: "Google's industry-recognized UX design certificate program — free to audit on Coursera.",
  },
  {
    id: "rv9",
    title: "Framer — Interactive Prototyping",
    url: "https://framer.com",
    domain: "framer.com",
    format: "Link",
    category: "Tools",
    tags: ["Prototyping", "Framer"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Mar 26, 2026",
    sessionId: "s2",
    taskId: null,
    starred: false,
    description: "Framer is a powerful tool for creating high-fidelity interactive prototypes with real animations.",
  },
  {
    id: "rv10",
    title: "Mobbin — UI Inspiration Library",
    url: "https://mobbin.com",
    domain: "mobbin.com",
    format: "Link",
    category: "Research",
    tags: ["UI Patterns", "Inspiration"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Mar 26, 2026",
    sessionId: "s2",
    taskId: null,
    starred: false,
    description: "Curated library of real app screenshots organized by UI pattern — perfect for design research.",
  },
  {
    id: "rv11",
    title: "Nielsen Norman Group Articles",
    url: "https://nngroup.com/articles",
    domain: "nngroup.com/articles",
    format: "Link",
    category: "Research",
    tags: ["UX Research", "Articles"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Mar 26, 2026",
    sessionId: "s2",
    taskId: null,
    starred: false,
    description: "The world's leading UX research firm — hundreds of evidence-based articles on UX best practices.",
  },
  {
    id: "rv12",
    title: "ADPList Mentorship Community",
    url: "https://adplist.org",
    domain: "adplist.org",
    format: "Link",
    category: "Learning",
    tags: ["Mentorship", "Community"],
    sharedBy: "Marcus Rodriguez",
    sharedDate: "Feb 28, 2026",
    sessionId: "s3",
    taskId: null,
    starred: false,
    description: "Free mentorship platform connecting mentees with experienced designers and tech professionals.",
  },
  {
    id: "rv13",
    title: "Cracking the Coding Interview",
    url: "https://amazon.com/cracking-coding-interview",
    domain: "amazon.com",
    format: "eBook",
    category: "Interview",
    tags: ["Interview", "Algorithms"],
    sharedBy: "Marcus Rodriguez",
    sharedDate: "Mar 22, 2026",
    sessionId: "s5",
    taskId: null,
    starred: false,
    description: "The definitive guide to technical interview preparation — covers data structures, algorithms, and system design.",
  },
  {
    id: "rv14",
    title: "UX Portfolio Checklist PDF",
    url: "https://uxdesign.cc/portfolio-checklist.pdf",
    domain: "uxdesign.cc",
    format: "PDF",
    category: "Portfolio",
    tags: ["Portfolio", "Checklist"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Apr 9, 2026",
    sessionId: "s1",
    taskId: null,
    starred: true,
    description: "A comprehensive checklist to ensure your UX portfolio covers everything hiring managers look for.",
  },
  {
    id: "rv15",
    title: "Figma Auto Layout Masterclass",
    url: "https://youtube.com/watch?v=figma-autolayout",
    domain: "youtube.com",
    format: "Video",
    category: "Learning",
    tags: ["Figma", "Auto Layout"],
    sharedBy: "Dr. Sarah Chen",
    sharedDate: "Apr 5, 2026",
    sessionId: "s4",
    taskId: null,
    starred: false,
    description: "A 45-minute deep dive into Figma Auto Layout — from basics to advanced responsive component patterns.",
  },
];
